import { SHIPPING_MODEL_CONST, type ShippingModelConfig } from './ShippingModelOption.d';
import { ShippingModel } from './ShippingModelOption.style';

const ShippingModelOption = ({ description, icon, title }: ShippingModelConfig) => (
  <ShippingModel.Component data-testid={SHIPPING_MODEL_CONST.TEST_ID}>
    <ShippingModel.IconWrapper>{icon}</ShippingModel.IconWrapper>

    <ShippingModel.Info>
      <ShippingModel.Title>{title}</ShippingModel.Title>
      <ShippingModel.Description>{description}</ShippingModel.Description>
    </ShippingModel.Info>
  </ShippingModel.Component>
);

export default ShippingModelOption;
